// src/utils/authMonitor.js

/**
 * 多标签登录状态监控工具
 */
const AuthMonitor = {
  // 存储当前标签页的用户标识
  currentUser: null,

  // 存储事件监听器引用，用于后续移除
  storageEventListener: null,

  /**
   * 初始化监控
   * @param {Function} onConflictDetected - 冲突检测回调函数
   */
  init (onConflictDetected) {
    // 从localStorage获取当前用户信息
    this.currentUser = this.getUserIdentifier()

    // 监听storage事件（跨标签页通信）
    this.storageEventListener = (event) => {
      if (event.key === 'multiTabAuthCheck') {
        this.handleStorageEvent(event, onConflictDetected)
      }
    }
    window.addEventListener('storage', this.storageEventListener)

    // 设置心跳检测，定期验证用户一致性
    this.setupHeartbeat()

    // 在页面卸载时清理
    window.addEventListener('beforeunload', this.cleanup.bind(this))
  },

  /**
   * 获取用户唯一标识
   */
  getUserIdentifier () {
    // 从localStorage获取用户信息
    const userData = localStorage.getItem('authMonitor')
    if (!userData) return null

    try {
      const user = JSON.parse(userData)
      // 返回能唯一标识用户的信息，如用户ID或用户名
      return user.userId || null
    } catch (e) {
      console.error('解析用户信息失败', e)
      return null
    }
  },

  /**
   * 处理storage事件
   */
  handleStorageEvent (event, onConflictDetected) {
    try {
      const { user, timestamp } = JSON.parse(event.newValue)

      // 如果检测到其他标签页的用户与当前不一致
      if (user && this.currentUser && user !== this.currentUser) {
        console.warn('检测到多标签页登录冲突', timestamp)
        if (typeof onConflictDetected === 'function') {
          onConflictDetected()
        } else {
          this.defaultConflictHandler()
        }
      }
    } catch (e) {
      console.error('处理storage事件失败', e)
    }
  },

  /**
   * 默认冲突处理方式
   */
  defaultConflictHandler () {
    // 可以根据需要选择刷新页面或退出登录
    // 方案1: 刷新页面
    window.location.reload()

    // 方案2: 退出登录
    // this.logout();
  },

  /**
   * 退出登录
   */
  logout () {
    // 清除用户信息
    localStorage.removeItem('authMonitor')
    // 跳转到登录页
    window.location.href = '/login'
  },

  /**
   * 设置心跳检测
   */
  setupHeartbeat () {
    // 每5秒发送一次心跳检测
    this.heartbeatInterval = setInterval(() => {
      this.sendHeartbeat()
    }, 5000)

    // 初始发送一次
    this.sendHeartbeat()
  },

  /**
   * 发送心跳检测
   */
  sendHeartbeat () {
    const currentUser = this.getUserIdentifier()
    if (currentUser) {
      localStorage.setItem('multiTabAuthCheck', JSON.stringify({
        user: currentUser,
        timestamp: Date.now()
      }))
    }
  },

  /**
   * 清理资源
   */
  cleanup () {
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval)
    }
    if (this.storageEventListener) {
      window.removeEventListener('storage', this.storageEventListener)
    }
    window.removeEventListener('beforeunload', this.cleanup.bind(this))
  }
}

export default AuthMonitor
